module.exports = __webpack_public_path__ + "static/logo-3238c162c67910031b84e8edfb6f1dcb.svg";